import { HttpErrorResponse } from '@angular/common/http';
import { ErrorCode, httpStatusToErrorCode } from 'app/shared/models/error.models';

export function toGoalErrorCode(error: unknown): ErrorCode {
  if (!(error instanceof HttpErrorResponse)) return ErrorCode.UNKNOWN_ERROR;

  if (error.status === 400) return ErrorCode.INVALID_GOAL;
  if (error.status === 404) return ErrorCode.USER_NOT_FOUND;

  return httpStatusToErrorCode(error.status) ?? ErrorCode.UNKNOWN_ERROR;
}
